import type { SortOption } from '@/components/ui/SortControls';

export const TASK_SORT_OPTIONS: SortOption[] = [
  { value: 'createdAt', labelKey: 'sorting.createdAt' },
  { value: 'title', labelKey: 'sorting.title' },
  { value: 'priority', labelKey: 'sorting.priority' },
  { value: 'status', labelKey: 'sorting.status' },
  { value: 'dueDate', labelKey: 'sorting.dueDate' },
  { value: 'assignee', labelKey: 'sorting.assignee' },
  { value: 'location', labelKey: 'sorting.location' },
  { value: 'progress', labelKey: 'sorting.progress' },
];

export const NOTE_SORT_OPTIONS: SortOption[] = [
  { value: 'updatedAt', labelKey: 'sorting.updatedAt' },
  { value: 'title', labelKey: 'sorting.title' },
  { value: 'createdAt', labelKey: 'sorting.createdAt' },
  { value: 'author', labelKey: 'sorting.author' },
  { value: 'location', labelKey: 'sorting.location' },
  { value: 'visibility', labelKey: 'sorting.visibility' },
];

export const OBSTRUCTION_SORT_OPTIONS: SortOption[] = [
  { value: 'createdAt', labelKey: 'sorting.createdAt' },
  { value: 'updatedAt', labelKey: 'sorting.updatedAt' },
  { value: 'title', labelKey: 'sorting.title' },
  { value: 'plannedStartDate', labelKey: 'sorting.plannedStartDate' },
  { value: 'plannedEndDate', labelKey: 'sorting.plannedEndDate' },
  { value: 'status', labelKey: 'sorting.status' },
  { value: 'severity', labelKey: 'sorting.severity' },
];

/** Default sort field per artifact kind when the viewer has not chosen one.
 * All kinds default to createdAt DESC to match the backend's initial (no-params) order. */
export const DEFAULT_TASK_SORT_BY = 'createdAt';
export const DEFAULT_NOTE_SORT_BY = 'createdAt';
export const DEFAULT_OBSTRUCTION_SORT_BY = 'createdAt';

/** Default sort direction (newest / highest first) when none is chosen. */
export const DEFAULT_SORT_DESCENDING = true;

/** Person-based sort fields, hidden when personal data is anonymized. */
export const TASK_PERSON_SORT_FIELD = 'assignee';
export const NOTE_PERSON_SORT_FIELD = 'author';
